import { Component, OnInit } from '@angular/core';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';
import { Router, ActivatedRoute } from '@angular/router';
import { disableDebugTools } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-vendororder',
  templateUrl: './vendororder.component.html',
  styleUrls: ['./vendororder.component.css']
})
export class VendororderComponent implements OnInit {

  data: any;
  pono: string;

  isUserSiteinc: boolean;
  isUserTransport: boolean;

  constructor(private engineeringservice: EngineeringService, private router: Router,
    private route: ActivatedRoute, private userService: UserService) {

    this.userService.isUserSiteinc.subscribe(
      value => {
        this.isUserSiteinc = value;
      }
    );
    this.userService.isUserTransport.subscribe(
      value => {
        this.isUserTransport = value;
      }
    );

  }

  ngOnInit() {
    this.getpurchaseheader();
  }
  getpurchaseheader() {
    debugger;
    this.engineeringservice.GetPurchaseOrderForVendor().subscribe(
      data => {
        this.data = data;
        console.log(data);
      }
    )

  }

  viewOrder(id) {
    debugger;
    //alert(id);
    this.router.navigate(['/viewpurchaseorder/' + id + '']);

    // this.engineeringservice.GetPurchaseline(id).subscribe(
    //   data => {
    //     this.data = data;
    //     console.log(data);
    //   })

  }

  transportDetails(id) {
    debugger;
    //alert(id);
    this.router.navigate(['/addtransportdtls/' + id + '']);

    // this.engineeringservice.GetPurchaseline(id).subscribe(
    //   data => {
    //     this.data = data;
    //     console.log(data);
    //   })

  }

}
